import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild, AfterContentInit, ElementRef } from '@angular/core';

import { Utils } from 'src/app/utils/utils';
import { AppComponent } from 'src/app/app.component';
import { NzModalService } from 'ng-zorro-antd/modal';
import { MainComponent } from '../../main/main.component';
import { environment } from 'src/environments/environment';

import { JqWidgets } from 'src/app/utils/jqWidgets';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';
import { jqxDropDownButtonComponent } from 'jqwidgets-ng/jqxdropdownbutton';

import { SsoService } from 'src/app/services/sso/sso.service';
import { TarjetasService } from 'src/app/services/ciudadanos/tarjetas/tarjetas.service';

import { TarjetaModel } from 'src/app/services/ciudadanos/models/tarjeta.model';
import { CiudadanoModel } from 'src/app/services/ciudadanos/models/ciudadano.model';
import { DireccionModel } from 'src/app/services/ciudadanos/models/direccion.model';
import { TarjetaListTransformerService, Type } from 'src/app/services/type-list-transformer.service';

@Component({
  selector: 'app-ciudadanos-tarjetas',
  templateUrl: './ciudadanos-tarjetas.component.html',
  styleUrls: ['./ciudadanos-tarjetas.component.css']
})
export class CiudadanosTarjetasComponent implements OnInit, OnChanges, AfterContentInit {
  // Componentes del HTML
  @ViewChild('gridTarjetasAsignadas') gridTarjetasAsignadas: jqxGridComponent;
  @ViewChild('gridTarjetasLibres') gridTarjetasLibres: jqxGridComponent;
  @ViewChild('searchInput', { static: true }) searchInput!: ElementRef<HTMLInputElement>;

  // Entradas
  @Input() ciudadano: CiudadanoModel;
  @Input() inputDireccion: number;
  @Input() guardar = false;

  // Funcionalidad
  public environment = environment;
  public langGrid = JqWidgets.getLocalization('es');

  public cellClass = (row: number, columnfield: unknown, value: unknown): string => {
    if (value) {
      return 'cellTooltip';
    }
    return '';
  }

  // Grid asignadas
  public columnsTarjetasAsignadas = [
    { text: 'Id', columntype: 'textbox', datafield: 'id', width: 80, hidden: true },
    { text: this.translate('Num_tarjeta'), columntype: 'textbox', datafield: 'idTarjeta', width: 85 },
    { text: this.translate('Ns_movisat'), columntype: 'textbox', datafield: 'nsMovisat', editable: false, width: 85, cellclassname: this.cellClass },
    { text: this.translate('Descripcion'), columntype: 'textbox', datafield: 'descripcion', editable: false, cellclassname: this.cellClass },
    { text: this.translate('Tipo'), columntype: 'textbox', filtertype: 'checkedlist',datafield: 'typeLabel', width: 60, cellclassname: this.cellClass },
    { text: this.translate('Lista'), columntype: 'textbox', filtertype: 'checkedlist',datafield: 'listTypeLabel', width: 60, cellclassname: this.cellClass },
    { text: this.translate('Direccion'), columntype: 'textbox', filtertype: 'textbox', datafield: 'calle', width: 100, cellclassname: this.cellClass },
    { text: this.translate('Codigo_postal'), columntype: 'textbox', filtertype: 'textbox', datafield: 'codigoPostal', width: 60, cellclassname: this.cellClass },
    { text: this.translate('Poblacion'), columntype: 'textbox', filtertype: 'checkedlist', datafield: 'poblacion', width: 100, cellclassname: this.cellClass },
    { text: this.translate('Municipio'), columntype: 'textbox', filtertype: 'checkedlist', datafield: 'municipio', width: 100, cellclassname: this.cellClass },
    { text: this.translate('Provincia'), columntype: 'textbox', filtertype: 'checkedlist', datafield: 'provincia', width: 100, cellclassname: this.cellClass },
  ];

  public sourceTarjetasAsignadas: any = {
    datatype: 'json',
    datafields: [
      { name: 'idTarjeta', type: 'number', map: 'idTarjeta' },
      { name: 'id', type: 'number', map: 'id' },
      { name: 'typeLabel', type: 'string' },
      { name: 'listTypeLabel', type: 'string' },
      { name: 'nsMovisat', type: 'string', map: 'nsMovisat' },
      { name: 'descripcion', type: 'string', map: 'descripcion' },
      { name: 'calle', type: 'string', map: 'direccion>direccion' },
      { name: 'poblacion', type: 'string', map: 'direccion>poblacion' },
      { name: 'municipio', type: 'string', map: 'direccion>municipio' },
      { name: 'codigoPostal', type: 'string', map: 'direccion>codigoPostal' },
      { name: 'provincia', type: 'string', map: 'direccion>provincia' },
    ],
    localdata: [],
  };
  public adapterTarjetasAsignadas: any = new jqx.dataAdapter(this.sourceTarjetasAsignadas);

  loadTooltips = (columns: any[]) => {
    columns.forEach(column => {
      column.rendered = (element) => {
        const tooltipMessage = column.text;
        Utils.tooltiprenderer(element, tooltipMessage);
      };
    });
  };


  public tarjetaAsignadaSelect: TarjetaModel;

  // Tarjeta seleccionada para mover entre un grid y otro
  public tarjetasLibres: TarjetaModel[] = [];
  public tarjetasLibresVirgen: TarjetaModel[] = [];
  public columnsTarjetasLibres = [
    { text: 'Id', columntype: 'textbox', datafield: 'id', width: 80, hidden: true },
    { text: this.translate('Num_tarjeta'), columntype: 'textbox', datafield: 'idTarjeta', width: 85 },
    { text: this.translate('Descripcion'), columntype: 'textbox', datafield: 'descripcion' },
    { text: this.translate('Tipo'), columntype: 'textbox', datafield: 'typeLabel', filtertype: 'checkedlist', width: 60, cellclassname: this.cellClass },
    { text: this.translate('Lista'), columntype: 'textbox', datafield: 'listTypeLabel', filtertype: 'checkedlist', width: 60, cellclassname: this.cellClass },
    { text: this.translate('Ns_movisat'), columntype: 'textbox', datafield: 'nsMovisat', width: 85 },
    { text: this.translate('Ns_fabricante'), columntype: 'textbox', datafield: 'nsFabricante', width: 100, map: 'uuidHex' },
    { text: 'selec', datafield: 'selec', hidden: true },
  ];
  public sourceTarjetasLibres: any;
  public adapterTarjetasLibres: any;
  public tarjetaLibreSelect: TarjetaModel;

  // Listados de tarjetas que se van a asociar/desasociar al guardar el ciudadano
  public tarjetasToAssociate: any[] = [];
  public tarjetasToDisassociate: any[] = [];

  constructor(private tarjetaServicio: TarjetasService,
    private modal: NzModalService,
    private ssoService: SsoService,
    private tarjetaListTransformer: TarjetaListTransformerService,) {
  }

  // Traducción de los textos
  public translate(text: string): string {
    return AppComponent.translate(text);
  }

  ngOnInit() {
    this.langGrid = JqWidgets.getLocalization(this.ssoService.getTicket().Usuario.Idioma.Codigo.substring(0, 2));
  }

  ngAfterContentInit() {
    this.cargarGrids();
  }

  cargarGrids() {
    /*
      Si falla alguna inicialización que el resto continuen,
      no queremos que se muestre error, se pueden dar errores
      debido a que ciudadano no esta inicializado
    */
    try {
      this.initGridDirecciones();
    } catch (error) {
      console.debug(error);
    }
    try {
      this.initGridTarjetasLibres();
    } catch (error) {
      console.debug(error);
    }
    try {
      this.initGridTarjetasAsignadas();
    } catch (error) {
      console.debug(error);
    }
  }

  updatefilterconditions = (type: string, defaultconditions: any): string[] => {
    return Utils.updatefilterconditions(type, defaultconditions);
  };

  public filter(cellValue?: any, rowData?: any, dataField?: string, filterGroup?: any, defaultFilterResult?: boolean): any {
    let filterColumns = [
      'nsMovisat',
      'nsFabricante',
      'descripcion',
      'direccion'
    ]

    return Utils.filterRow(cellValue, dataField, filterGroup, defaultFilterResult, filterColumns);
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (const propName in changes) {
      if (changes.hasOwnProperty(propName)) {
        switch (propName) {
          case 'ciudadano':
            this.ciudadano = changes[propName].currentValue;

            if (this.ciudadano) {
              this.ciudadano.tarjetas = this.ciudadano.tarjetas.map(tarj =>
                this.tarjetaListTransformer.transform(tarj)
              );
              this.ciudadano.tarjetas.forEach(tarj => {
                this.ciudadano.direcciones.forEach(dir => {
                  if (tarj.direccion.id === dir.id) {
                    dir.numeroTarjetas = tarj.direccion.numeroTarjetas;
                  }
                })
              });
            }
            break;
          case 'inputDireccion':
            this.direccionSelec = changes[propName].currentValue;

            this.setCBDireccionesContent();
            break;
          case 'guardar':
            this.guardar = changes[propName].currentValue;
            if (this.guardar === true && this.ciudadano.id > 0) {
              this.onGuardar();
            }
            break;
          default:
            break;
        }
      }
    }
  }

  // Al llamar el metodo se hace la peticion al servidor
  async onGuardar() {
    await this.tarjetaServicio.associateTarjetasToCiudadano(this.tarjetasToAssociate, this.ciudadano.id);
    await this.tarjetaServicio.disassociateTarjetasFromCiudadano(this.tarjetasToDisassociate, this.ciudadano.id);

  }

  // Se llama cuando se cambia una tarjeta libre al grid de ciudadano
  associateTarjetasToCiudadano() {
    // Si la tarjeta no está grabada la mando grabar
    if (this.tarjetaLibreSelect.idInterno < 1) {
      this.onNewCard();
      return;
    }

    const direccionId = this.direccionSelec?.id;
    const tipoTarjeta = this.tarjetaLibreSelect.tipo;

    const tarjetasEnDireccion = this.ciudadano.tarjetas.filter(t =>
      t.direccion?.id === direccionId
    );

    if (tarjetasEnDireccion.length >= 3) {
      MainComponent.getInstance().showError(
        'ATENCION',
        'Max_tarjetas_por_direccion',
        2000
      );
      return;
    }

    if (tarjetasEnDireccion.find(t => t.tipo === tipoTarjeta)) {
      MainComponent.getInstance().showError(
        'ATENCION',
        'Tarjeta_tipo_duplicado',
        2000
      );
      return;
    }

    const tarjetaTransformada = this.tarjetaListTransformer.transform(this.tarjetaLibreSelect);
    // Si no está en la lista de asociadas la añado
    if (!this.tarjetasToAssociate.find(x => x.id === tarjetaTransformada.id)) {
      try {
        this.tarjetasToAssociate.push({ "id": tarjetaTransformada.id, "idDireccion": this.direccionSelec?.id });
      } catch (e) {
        MainComponent.getInstance().showError(
          'ATENCION',
          'Selecciona_direccion_tarjeta',
          2000
        );
      }
    }


    // Si está en la lista de desasociadas la quito
    for (let index = 0; index < this.tarjetasToDisassociate?.length; index++) {
      if (this.tarjetasToDisassociate[index].id === tarjetaTransformada.id) {
        this.tarjetasToDisassociate.splice(index, 1);
        break;
      }
    }

    // Si no está, la añado a la lista de tarjetas del ciudadano
    if (this.ciudadano && this.ciudadano.tarjetas && !this.ciudadano.tarjetas.find(x => x.id === tarjetaTransformada.id)) {
      tarjetaTransformada.direccion = this.direccionSelec;
      this.ciudadano.tarjetas.push(tarjetaTransformada);
      const dirIndex = this.ciudadano.direcciones.findIndex(dir => dir.id === direccionId);
      this.ciudadano.direcciones[dirIndex].numeroTarjetas++;
    }

    // Si está en la lista de tarjetas libres la quito
    for (let index = 0; index < this.tarjetasLibres?.length; index++) {
      if (this.tarjetasLibres[index].id === tarjetaTransformada.id) {
        this.tarjetasLibres.splice(index, 1);
        break;
      }
    }

    this.gridTarjetasLibres.clearselection();
    this.tarjetaLibreSelect = null;
    this.updateGrids();
    this.updateGridTarjetasAsignadas();
  }

  // Se llama cuando se cambia una tarjeta del grid de ciudadano a libre
  disassociateTarjetasFromCiudadano() {

  if (!this.tarjetaAsignadaSelect) {
    return;
  }
  const tarjetaTransformada = this.tarjetaListTransformer.transform(this.tarjetaAsignadaSelect);

    if (!this.tarjetasToDisassociate.find(x => x.id === tarjetaTransformada.id)) {
      this.tarjetasToDisassociate.push({ "id": tarjetaTransformada.id, "idDireccion": tarjetaTransformada.direccion.id });
    }
    // Si está en la lista de asociadas la quito
    for (let index = 0; index < this.tarjetasToAssociate?.length; index++) {
      if (this.tarjetasToAssociate[index].id === tarjetaTransformada.id) {
        this.tarjetasToAssociate.splice(index, 1);
        break;
      }
    }
    // Si está en la lista de tarjetas del ciudadano la quito
    for (let index = 0; this.ciudadano.tarjetas && index < this.ciudadano.tarjetas?.length; index++) {
      if (this.ciudadano.tarjetas[index].id === tarjetaTransformada.id) {
        this.ciudadano.tarjetas.splice(index, 1);
        let dirIndex = this.ciudadano.direcciones.findIndex(dir => dir.id === this.direccionSelec.id);
        this.ciudadano.direcciones[dirIndex].numeroTarjetas--;
        break;
      }
    }
    // Si no está en la lista de tarjetas libres la añado
    if (this.tarjetasLibres && !this.tarjetasLibres.find(x => x.id === tarjetaTransformada.id)) {
      this.tarjetasLibres.push(tarjetaTransformada);
    }
    this.gridTarjetasAsignadas.clearselection();
    this.tarjetaAsignadaSelect = null;
    this.updateGrids();

    this.updateGridTarjetasAsignadas();
  }


  protected onBuscar(event): void {
    const filterValue = event.target.value.normaliceAccents().toLowerCase();

    if (filterValue.length >= 3) {
      const applyFilterToAllColumns = (grid: jqxGridComponent, data: any[]) => {
        data.forEach((row) => {
          const matchesSearch = Object.values(row).some((value) => {
            const stringValue = value !== undefined && value !== null ? String(value) : '';
            return stringValue.normaliceAccents().toLowerCase().includes(filterValue);
          });
          row['selec'] = matchesSearch ? 'selec' : '';
        });

        this.__ensureGridFiltersAreRegistered(grid);
        this.__tirggerGridFilters(grid);
      };

      applyFilterToAllColumns(this.gridTarjetasLibres, this.tarjetasLibres);
    } else {
      this.gridTarjetasLibres.clearfilters();
      this.gridTarjetasLibres.updatebounddata('data');
    }
  }

  private __ensureGridFiltersAreRegistered(grid: jqxGridComponent): void {
    let filters;

    try {
      // XXX: {aalzate} Parece que hay un filtro mal configurado cuando entra aquí. con el try...catch lo atrapamos y saltamos.
      filters = grid.getfilterinformation();
    } catch (error) {
      filters = [];
    }

    if (!filters.some(filter => filter.datafield === 'selec')) {
      const filtergroup = new jqx.filter();
      filtergroup.operator = 'and';

      const filter = filtergroup.createfilter('stringfilter', 'selec', 'contains');
      filtergroup.addfilter(0, filter);
      grid.addfilter('selec', filtergroup);
    }
  }

  private __tirggerGridFilters(grid: jqxGridComponent): void {
    grid.applyfilters();
    grid.updatebounddata('data');
  }

  updateGrids() {

    this.gridTarjetasLibres.updatebounddata('data');
    this.gridTarjetasAsignadas.updatebounddata('data');
  }

  private formatearDireccion(direccion: { direccion: string; numero?: string }): string {
    if (!direccion?.direccion) return;
    return direccion.numero?.trim() ? `${direccion.direccion}, ${direccion.numero}` : direccion.direccion;
  }

  // Inicializa el grid de tarjetas asociadas al ciudadano
  async initGridTarjetasAsignadas() {
    if (this.ciudadano && this.ciudadano.id != 0) {
      this.ciudadano.tarjetas.sort((a, b) => (a.nsMovisat > b.nsMovisat) ? 1 : ((b.nsMovisat > a.nsMovisat) ? -1 : 0));
    }

    let tarjToShow: TarjetaModel[] = []
    if (this.ciudadano && this.direccionSelec && this.direccionSelec.id >= 0) {
      this.ciudadano.tarjetas.forEach(tarj => {
        if (tarj.direccion && tarj.direccion.id === this.direccionSelec.id) {
          tarjToShow.push(tarj);
        }
      });
    } else if (this.ciudadano) {
      tarjToShow = this.ciudadano.tarjetas;
    }

    tarjToShow = tarjToShow.map(tarjeta => {
      const transformada = this.tarjetaListTransformer.transform(tarjeta);
      return {
        ...transformada,
        direccion: transformada.direccion ? {
          ...transformada.direccion,
          direccion: this.formatearDireccion(transformada.direccion)
        } : undefined,
        listTypeLabel: transformada.listTypeLabel
      };
    });

    this.sourceTarjetasAsignadas.localdata = tarjToShow;

    this.adapterTarjetasAsignadas = new jqx.dataAdapter(this.sourceTarjetasAsignadas);

    if (this.ciudadano && this.ciudadano.tarjetas && this.ciudadano.tarjetas?.length > 0) {
      this.ciudadano.tarjetas.forEach(tarjeta => {
        this.tarjetasToAssociate.push({ "id": tarjeta.id,  "idDireccion": this.direccionSelec?.id });
      });
    }

    this.loadTooltips(this.columnsTarjetasAsignadas);
  }

  // Inicializa el grid de tarjetas libres (sólo las grabadas)
  async initGridTarjetasLibres() {
    this.tarjetasLibres = [];
    const res: TarjetaModel[] = await this.tarjetaServicio.getTarjetasLibres();
    if (res && res.length > 0) {
      res.forEach(tarjeta => {
        if (tarjeta.grabada) {
          const tarjetaTransformada = this.tarjetaListTransformer.transform(tarjeta);
          this.tarjetasLibres.push(tarjetaTransformada);
        } else {
          this.tarjetasLibresVirgen.push(tarjeta);
        }
      });
    }
    if (this.ciudadano?.tarjetas?.length > 0) {
      this.ciudadano.tarjetas.forEach(tarj => {
        const tarIndex = this.tarjetasLibres.findIndex(tarjLib => tarjLib.id === tarj.id);
        if (tarIndex !== -1) {
          this.tarjetasLibres.splice(tarIndex, 1);
        }
      });
    }
    this.tarjetasLibres.sort((a, b) => (a.nsMovisat > b.nsMovisat) ? 1 : -1);
    this.sourceTarjetasLibres = {
      datatype: 'json',
      datafields: [
        { name: 'idTarjeta', type: 'number', map: 'idTarjeta' },
        { name: 'id', type: 'number', map: 'id' },
        { name: 'nsMovisat', type: 'string', map: 'nsMovisat' },
        { name: 'descripcion', type: 'string', map: 'descripcion' },
        { name: 'uuidHex', type: 'string', map: 'uuidHex' },
        { name: 'typeLabel', type: 'string' },
        { name: 'listTypeLabel', type: 'string' },
        { name: 'selec', type: 'string', map: 'selec' },
      ],
      localdata: this.tarjetasLibres,
    };
    this.adapterTarjetasLibres = new jqx.dataAdapter(this.sourceTarjetasLibres);
    this.gridTarjetasLibres.updatebounddata();
    this.loadTooltips(this.columnsTarjetasLibres);
  }


  onRowSelectAsignada(event: any) {
    let index = this.ciudadano.tarjetas.findIndex(tarj => tarj.id === event.args.row.bounddata.id);
    this.tarjetaAsignadaSelect = this.ciudadano.tarjetas[index];
  }

  onRowSelectLibre(event: any) {
    this.tarjetaLibreSelect = this.tarjetasLibres[event.args.rowindex];
  }

  // Lee o graba una nueva tarjeta desde el grabador
  async onNewCard() {
    try {
      this.modal.confirm({
        nzTitle: '<i>' + AppComponent.translate('ATENCION') + '</i>',
        nzContent: AppComponent.translate('Quiere_grabar_tarjeta'),
        nzCentered: true,
        nzCancelText: AppComponent.translate('CANCELAR'),
        nzOkText: AppComponent.translate('ACEPTAR'),
        nzZIndex: 999,
        nzOnOk: async () => {
          try {
            // Obtengo los datos de la tarjeta que hay en el grabador
            const tarjeta = await this.tarjetaServicio.consultarTarjetaAGrabar();
            if (!tarjeta) {
              MainComponent.showError('ATENCION', 'No_hay_conexion_app_nfcwrite', 5000);
              return;
            }

            // Aplico el transformador para ajustar la estructura de la tarjeta
            const tarjetaTransformada = this.tarjetaListTransformer.transform(tarjeta);

            if (tarjetaTransformada.uuid && tarjetaTransformada.uuid > 0) {
              // Verifico si la tarjeta es virtual o no usando el transformador
              if (tarjetaTransformada.type === Type.VIRTUAL) {
                tarjetaTransformada.idZona = 255; // Para separar las tarjetas virtuales de las físicas

                let ultimaTarjeta: TarjetaModel;
                if (tarjetaTransformada.idTarjeta < 1) {
                  ultimaTarjeta = await this.tarjetaServicio.getUltimaTarjeta(tarjetaTransformada.idZona);
                } else {
                  // Validación para evitar asignaciones duplicadas
                  if (this.tarjetasLibres && !this.tarjetasLibres.find(x => x.nsMovisat === tarjetaTransformada.nsMovisat)) {
                    MainComponent.showError('ATENCION', "Tarjeta_asignada_otro_ciudadano", 3000);
                    return;
                  }
                }

                // Asignar los valores correspondientes a la tarjeta
                tarjetaTransformada.empresa = this.ssoService.getTicket().Empresa.IdGestion;

                if (tarjetaTransformada.idTarjeta < 1) {
                  tarjetaTransformada.idInterno = ultimaTarjeta ? ultimaTarjeta.idInterno + 1 : 1;
                  tarjetaTransformada.idTarjeta = (tarjetaTransformada.idInterno & 0xFFFFFF) + ((tarjetaTransformada.idZona & 0xFF) << 24);
                } else {
                  tarjetaTransformada.idInterno = (tarjetaTransformada.idTarjeta & 0xFFFFFF);
                }

                const res = await this.tarjetaServicio.grabaTarjeta(tarjetaTransformada);
                if (res) {
                  if ((res as any).Error) {
                    MainComponent.showError('ATENCION', (res as any).Error, 3000);
                  } else {
                    tarjetaTransformada.uuid = res.uuid;
                    tarjetaTransformada.nsMovisat = res.nsMovisat;
                    tarjetaTransformada.idZona = res.idZona;
                    tarjetaTransformada.idInterno = res.idInterno;
                    tarjetaTransformada.grabada = true;
                    tarjetaTransformada.idTarjeta = (res.idInterno & 0xFFFFFF) + ((res.idZona & 0xFF) << 24);
                    tarjetaTransformada.ciudadano = this.ciudadano;
                    tarjetaTransformada.descripcion = "TARJETA " + (tarjetaTransformada.type ? "V" + tarjetaTransformada.idInterno : tarjetaTransformada.idInterno);

                    // Graba la tarjeta creada
                    this.tarjetaLibreSelect = await this.tarjetaServicio.creaTarjeta(tarjetaTransformada);

                    if (this.tarjetaLibreSelect) {
                      // Si la tarjeta ya la tenía el ciudadano, la quito de la lista
                      for (let i = 0; i < this.ciudadano.tarjetas?.length; i++) {
                        if (this.ciudadano && this.ciudadano.tarjetas[i].id === this.tarjetaLibreSelect.id) {
                          this.ciudadano.tarjetas.splice(i, 1);
                          break;
                        }
                      }
                      this.associateTarjetasToCiudadano();
                      MainComponent.getInstance().showSuccess('ATENCION', 'Tarjeta_grabada', 2000);
                    }
                    return;
                  }
                } else {
                  MainComponent.showError('ATENCION', 'No_hay_conexion_app_nfcwrite', 5000);
                }
                return;
              }

              // Si la tarjeta no es virtual, validamos si ya está grabada
              this.tarjetaLibreSelect = this.tarjetasLibres.find(x => x.uuid === tarjetaTransformada.uuid);
              if (!this.tarjetaLibreSelect) {
                this.tarjetaLibreSelect = this.tarjetasLibresVirgen.find(x => x.uuid === tarjetaTransformada.uuid);
                if (!this.tarjetaLibreSelect) {
                  const tarjetas = await this.tarjetaServicio.getTarjetasWithCiudadanos();
                  if (tarjetas) {
                    const tc = tarjetas.find(x => x.uuid === tarjetaTransformada.uuid);
                    if (tc && !tc.ciudadano) {
                      if (tarjetaTransformada.grabada) {
                        this.tarjetasLibres.push({ ...tc });
                      } else {
                        this.tarjetasLibresVirgen.push({ ...tc });
                      }
                      this.tarjetaLibreSelect = { ...tc };
                    }
                  }
                }
              }

              if (this.tarjetaLibreSelect) {
                const idTarjetaExterno = this.getIdExterno(this.tarjetaLibreSelect);
                if (idTarjetaExterno < 1) {
                  MainComponent.showError('ATENCION', 'Tarjeta_no_registrada', 3000);
                  return;
                }

                if (this.tarjetaLibreSelect.idTarjeta !== idTarjetaExterno || tarjetaTransformada.idTarjeta !== idTarjetaExterno) {
                  // Graba la tarjeta si no es la misma
                  tarjetaTransformada.empresa = this.ssoService.getTicket().Empresa.IdGestion;
                  tarjetaTransformada.idZona = (idTarjetaExterno & 0xFF000000) >> 24;
                  tarjetaTransformada.idInterno = (idTarjetaExterno & 0xFFFFFF);
                  tarjetaTransformada.grabada = true;
                  tarjetaTransformada.idExterno = this.tarjetaLibreSelect.idExterno;
                  tarjetaTransformada.idTarjeta = (tarjetaTransformada.idInterno & 0xFFFFFF) + ((tarjetaTransformada.idZona & 0xFF) << 24);
                  tarjetaTransformada.nsMovisat = this.tarjetaLibreSelect.nsMovisat;
                  tarjetaTransformada.ciudadano = this.ciudadano;
                  tarjetaTransformada.descripcion = "TARJETA " + (tarjetaTransformada.type ? "V" + tarjetaTransformada.idInterno : tarjetaTransformada.idInterno);
                  const res = await this.tarjetaServicio.grabaTarjeta(tarjetaTransformada);
                  if (res) {
                    if ((res as any).Error) {
                      MainComponent.showError('ATENCION', (res as any).Error, 3000);
                    } else {
                      const tarjetaLibre = this.tarjetasLibresVirgen.find(x => x.nsMovisat === tarjetaTransformada.nsMovisat);
                      if (tarjetaLibre) {
                        this.tarjetasLibres.push(Utils.clone(tarjetaLibre));
                        for (let i = 0; i < this.tarjetasLibresVirgen?.length; i++) {
                          if (this.tarjetasLibresVirgen[i].id === tarjetaLibre.id) {
                            this.tarjetasLibresVirgen.splice(i, 1);
                            break;
                          }
                        }
                      }
                      this.tarjetaLibreSelect = await this.tarjetaServicio.creaTarjeta(tarjetaTransformada);
                      if (this.tarjetaLibreSelect) {
                        this.saveTarjeta();
                      }
                    }
                  } else {
                    MainComponent.showError('ATENCION', 'No_hay_conexion_app_nfcwrite', 5000);
                  }
                } else {
                  this.saveTarjeta();
                }
              } else {
                if (this.tarjetasToAssociate && !this.tarjetasToAssociate.find(x => x.id === tarjetaTransformada.id)) {
                  const tarjetasCiudadano = await this.tarjetaServicio.getTarjetasWithCiudadanos();
                  let tm: TarjetaModel;
                  if ((tm = tarjetasCiudadano.find(x => x.uuid === tarjetaTransformada.uuid))) {
                    if (tm.ciudadano && tm.ciudadano.id !== this.ciudadano.id) {
                      MainComponent.showError('ATENCION', "Tarjeta_asignada_otro_ciudadano", 3000);
                    }
                  } else {
                    MainComponent.showError('ATENCION', 'Tarjeta_no_registrada', 3000);
                  }
                } else {
                  MainComponent.showError('ATENCION', 'Tarjeta_no_registrada', 3000);
                }
              }
            }
          } catch (error) {
            MainComponent.showError('ATENCION', 'Error_inesperado', 5000);
            console.error(error);
          }
        }
      });
    } catch (e) {
      console.log('Error al confirmar la acción de grabado de tarjeta:', e);
    }
  }

  saveTarjeta() {
    for (let i = 0; i < this.ciudadano.tarjetas?.length; i++) {
      if (this.ciudadano && this.ciudadano.tarjetas[i].id === this.tarjetaLibreSelect.id) {
        this.ciudadano.tarjetas.splice(i, 1);
        break;
      }
    }
    const tarjetaTransformada = this.tarjetaListTransformer.transform(this.tarjetaLibreSelect);

    this.tarjetaLibreSelect = tarjetaTransformada;
    this.associateTarjetasToCiudadano();
    MainComponent.getInstance().showSuccess('ATENCION', 'Tarjeta_grabada', 2000);
  }


  getIdExterno(tarjeta: TarjetaModel): number {
    return tarjeta.idInterno;
  }


  @ViewChild('gridDropDownDirecciones') gridDropDownDirecciones: jqxGridComponent;
  @ViewChild('cbDirecciones') cbDirecciones: jqxDropDownButtonComponent;

  protected direccionSelec: DireccionModel;

  verGridDirecciones: boolean = false;
  public columnsDirecciones: any = [
    { text: 'Id', columntype: 'textbox', datafield: 'id', width: 80, hidden: true },
    { text: this.translate('Num_tarjetas'), columntype: 'textbox', datafield: 'numeroTarjetas', width: 80 },
    { text: this.translate('Num_abonado'), columntype: 'textbox', datafield: 'numeroAbonado' },
    { text: this.translate('Numero_catastro'), columntype: 'textbox', datafield: 'numeroCatastro' },
    { text: this.translate('Direccion_catastro'), columntype: 'textbox', datafield: 'direccionCatastro' },
    { text: this.translate('Direccion'), columntype: 'textbox', datafield: 'direccion' },
    { text: this.translate('Numero'), columntype: 'textbox', datafield: 'numero' },
    { text: this.translate('Municipio'), columntype: 'textbox', datafield: 'municipio' },
    { text: this.translate('Provincia'), columntype: 'textbox', datafield: 'provincia' },
  ];

  public sourceDirecciones: any = {
    datatype: 'json',
    datafields: [
      { name: 'id', type: 'number', map: 'id' },
      { name: 'numeroTarjetas', type: 'string', map: 'numeroTarjetas' },
      { name: 'numeroAbonado', type: 'string', map: 'numeroAbonado' },
      { name: 'numeroCatastro', type: 'string', map: 'catastro>referenciaCatastral' },
      { name: 'direccionCatastro', type: 'string', map: 'catastro>direccionCatastral' },
      { name: 'direccion', type: 'string', map: 'direccion' },
      { name: 'numero', type: 'string', map: 'numero' },
      { name: 'municipio', type: 'string', map: 'municipio' },
      { name: 'provincia', type: 'string', map: 'provincia' },
    ],
    localdata: [],
  };
  public adapterDirecciones: any = new jqx.dataAdapter(this.sourceDirecciones);

  initGridDirecciones() {
    if (!this.direccionSelec) {
      if (this.ciudadano && this.ciudadano.direcciones) {
        this.ciudadano.direcciones.forEach(dir => {
          if (dir.direccionPrincipal) {
            this.direccionSelec = dir;
          }
        });

        this.ciudadano.direcciones.sort((a, b) => (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0));

        this.setCBDireccionesContent();
      } else {
        this.ciudadano.direcciones = [];
      }
    }else {
      this.setCBDireccionesContent();
    }

    this.columnsDirecciones = [
      { text: 'Id', columntype: 'textbox', datafield: 'id', width: 80, hidden: true },
      { text: this.translate('Num_tarjetas'), columntype: 'textbox', datafield: 'numeroTarjetas', width: 80, cellclassname: this.cellClass },
      { text: this.translate('Num_abonado'), columntype: 'textbox', datafield: 'numeroAbonado' },
      { text: this.translate('Numero_catastro'), columntype: 'textbox', datafield: 'numeroCatastro', cellclassname: this.cellClass },
      { text: this.translate('Direccion_catastro'), columntype: 'textbox', datafield: 'direccionCatastro', cellclassname: this.cellClass },
      { text: this.translate('Direccion'), columntype: 'textbox', datafield: 'direccion', cellclassname: this.cellClass },
      { text: this.translate('Numero'), columntype: 'textbox', datafield: 'numero', cellclassname: this.cellClass },
      { text: this.translate('Municipio'), columntype: 'textbox', datafield: 'municipio', cellclassname: this.cellClass },
      { text: this.translate('Provincia'), columntype: 'textbox', datafield: 'provincia', cellclassname: this.cellClass },
    ];

    this.ciudadano.direcciones.forEach(dir => {
      try {
        if(dir && dir.catastro) {
          dir.catastro['direccionCatastral'] = dir?.catastro?.direccion != '' ? dir?.catastro?.direccion : '';
          dir.catastro['direccionCatastral'] +=  dir?.catastro?.numero != '' ? (dir?.catastro['direccionCatastral'] !== '' ? ', ' + dir.catastro?.numero : dir.catastro?.numero) : '';
        }
      } catch (error) {

      }
    });

    this.sourceDirecciones = {
      datatype: 'json',
      datafields: [
        { name: 'id', type: 'number', map: 'id' },
        { name: 'numeroTarjetas', type: 'string', map: 'numeroTarjetas' },
        { name: 'numeroAbonado', type: 'string', map: 'numeroAbonado' },
        { name: 'numeroCatastro', type: 'string', map: 'catastro>referenciaCatastral' },
        { name: 'direccionCatastro', type: 'string', map: 'catastro>direccionCatastral' },
        { name: 'direccion', type: 'string', map: 'direccion' },
        { name: 'numero', type: 'string', map: 'numero' },
        { name: 'municipio', type: 'string', map: 'municipio' },
        { name: 'provincia', type: 'string', map: 'provincia' },
      ],
      localdata: this.ciudadano.direcciones,
    }
    this.adapterDirecciones = new jqx.dataAdapter(this.sourceDirecciones);
  }

  onOpenSelectDirecciones(event) {
    this.customComponent();
    this.verGridDirecciones = true;
  }

  customComponent(component?: any) {
    setTimeout(() => {
      this.gridDropDownDirecciones.setOptions({
        showaggregates: true,
        sortable: true,
        altrows: true,
        filterable: true,
        rowsheight: 20,
        columnsheight: 20,
        statusbarheight: 20,
        columnsresize: true,
        showstatusbar: true,
        showcolumnlines: true,
      });
    }, 50);
  }

  onCloseSelectDirecciones(event) {
    this.verGridDirecciones = false;
  }

  /* Cuando se selecciona una direccion */
  onRowClickDirecciones(event: any) {
    this.direccionSelec = this.ciudadano.direcciones[event.args.rowindex];

    this.setCBDireccionesContent();

    this.cbDirecciones.close();
  }

  onAsignarDireccion(event: any) {
    if(this.direccionSelec) {
      let tarjSelecIndex = this.tarjetasToAssociate.findIndex(tarj => tarj.id === this.tarjetaAsignadaSelect.id);
      let tarjCiudIndex = this.ciudadano.tarjetas.findIndex(tarj => tarj.id === this.tarjetaAsignadaSelect.id);

      this.ciudadano.tarjetas[tarjCiudIndex].direccion = this.direccionSelec;
      this.tarjetasToAssociate[tarjSelecIndex].idDireccion = this.direccionSelec.id;


      this.updateGrids();
    }
  }

  setCBDireccionesContent() {
    if (this.direccionSelec) {
      let content = '<div style="position: relative; margin-left: 3px; margin-top: 5px;">';

      content += (this.direccionSelec.direccion ? this.direccionSelec.direccion : '') +
        (this.direccionSelec.numero ? ', ' + this.direccionSelec.numero : '') +
        (this.direccionSelec.municipio ? ', ' + this.direccionSelec.municipio : '') +
        (this.direccionSelec.provincia ? ', ' + this.direccionSelec.provincia : '');

      if(this.direccionSelec.catastro) {
        content +=
        '(' +
          (this.direccionSelec.catastro.referenciaCatastral ? this.direccionSelec.catastro.referenciaCatastral : '') +
          (this.direccionSelec.catastro['direccionCatastral'] ? ', ' + this.direccionSelec.catastro['direccionCatastral'] : '') +
        ')';
      }

      content += '</div>';

      if (this.cbDirecciones) {
        this.cbDirecciones.setContent(content);
      }

      this.updateGridTarjetasAsignadas();
    }
  }

  updateGridTarjetasAsignadas() {
    let tarjToShow: TarjetaModel[] = []
    if (this.ciudadano && this.direccionSelec?.id >= 0) {
      this.ciudadano.tarjetas.forEach(tarj => {
        if (tarj.direccion && tarj.direccion.id === this.direccionSelec.id) {
          tarjToShow.push(tarj);
        }
      });
    } else {
      tarjToShow = this.ciudadano && this.ciudadano.tarjetas ? this.ciudadano.tarjetas : [];
    }
    const tarjetasTransformadas = tarjToShow.map(tarjeta => {
      const transformada = this.tarjetaListTransformer.transform(tarjeta);
      return {
        ...transformada,
        direccion: transformada.direccion ? {
          ...transformada.direccion,
          direccion: this.formatearDireccion(transformada.direccion),
        } : undefined,
        listTypeLabel: transformada.listTypeLabel
      };
    });
    if (this.sourceTarjetasAsignadas && this.gridTarjetasAsignadas) {
      this.sourceTarjetasAsignadas.localdata = tarjetasTransformadas;
      this.gridTarjetasAsignadas.updatebounddata();
    }
  }
}
